import vosClient, { IVosResponse } from "../../vosClient";

export interface IGetRouteListParams {
  keySearch?: string;
}

export interface RouteItem {
  AirportName: string;
  AirportCode: string;
}

export class RouteService {
  static async getRouteList(params?: IGetRouteListParams) {
    const response = await vosClient.get<IVosResponse<RouteItem[]>>("/api/department/code-airport-get", {
      params,
    });

    return response.data;
  }
}
